export default "__VITE_ASSET__DrPmEUEI__"